export default "__VITE_ASSET__BIL2lG73__"